/* eslint-disable no-unused-vars */

enum EContacts {
  PHONE_NUMBER = "+380674803160",
  EMAIL = "sales@example.com",
  NAME = "Oleksandr",
}
export { EContacts };
